<template>
  <asc-dialog
    :show-dialog="showDialog"
    :text="getDialogText"
    :on-close="handlePlotDialogClose"
    :on-primary="handleAccept"
    :primary-button-text="getDialogPrimaryButtonText"
    :primary-available="isCurrentDataValid"
    :width="1000"
  >
    <template v-if="showDialog">
      <asc-spinner-wrapper :loading="loading">
        <div class="asc-page-plot-dialog--container">
          <template v-if="editable">
            <asc-label
              value="View and make edits to this plot, then click 'Apply'."
            ></asc-label>
          </template>
          <asc-page-plot-wrapper
            live-chart
            mx-rec-plot
            plot-editor
            :page-plot="pagePlot"
            :loading-plot-ids="loadingPlotIds"
            :chart-data="chartData"
            :filter-lookups="filterLookups"
            :action-buttons="false"
            :is-close-button-visible="false"
            :is-duplicate-button-visible="false"
            :is-associate-button-visible="false"
            :mini-plot="false"
            :editable="editable"
            :saving="saving"
            :readonly="readonly"
            :on-apply-page-plot="handleApplyPagePlot"
            :on-add-tab-to-page-plot="handleAddTabToPagePlot"
            :on-remove-tab-from-page-plot="handleRemoveTabFromPagePlot"
            :on-save-page-plot="handleSavePagePlot"
            :on-update-page-plot-caption="handleUpdatePagePlotCaption"
            :on-update-tab-view-page-plot="handleUpdateTabViewPagePlot"
            :hide-hidden-tabs="hideHiddenTabs"
            :is-tab-menu-disabled="isTabMenuDisabled"
          ></asc-page-plot-wrapper>
        </div>
      </asc-spinner-wrapper>
    </template>
  </asc-dialog>
</template>

<script>
import AscDialog from '@/components/atoms/AscDialog'
import AscLabel from '@/components/atoms/AscLabel'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import { AscDialogMixin } from '@/components/mixins'
import AscPagePlotWrapper from '@/components/organisms/AscPagePlotWrapper'

export default {
  name: 'AscPagePlotDialog',

  components: {
    AscDialog,
    AscLabel,
    AscPagePlotWrapper,
    AscSpinnerWrapper,
  },

  mixins: [AscDialogMixin],

  props: {
    pagePlot: {
      type: Object,
      default: () => {},
    },
    loadingPlotIds: {
      type: Array,
      default: () => [],
    },
    chartData: {
      type: Array,
      default: () => [],
    },
    filterLookups: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    onApplyPagePlot: {
      type: Function,
      default: () => {},
    },
    onAddTabToPagePlot: {
      type: Function,
      default: () => {},
    },
    onRemoveTabFromPagePlot: {
      type: Function,
      default: () => {},
    },
    onSavePagePlot: {
      type: Function,
      default: () => {},
    },
    onUpdatePagePlotCaption: {
      type: Function,
      default: () => {},
    },
    onUpdateTabViewPagePlot: {
      type: Function,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hideHiddenTabs: {
      type: Boolean,
      default: false,
    },
    isTabMenuDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentData: null,
      isUpdated: false,
      isSaved: false,
    }
  },

  computed: {
    getDialogText() {
      return this.editable ? 'View and Edit Plot' : 'View Plot'
    },

    getDialogPrimaryButtonText() {
      return 'Close'
    },

    isCurrentDataValid() {
      return true
    },
  },

  methods: {
    handleSavePagePlot(plotId) {
      this.isSaved = true
      this.onSavePagePlot(plotId)
    },
    handleUpdatePagePlotCaption(plotId, typeId, caption) {
      this.isUpdated = true
      this.onUpdatePagePlotCaption(plotId, typeId, caption)
    },
    handleAddTabToPagePlot(plotId, tabIndex) {
      this.isUpdated = true
      this.onAddTabToPagePlot(plotId, tabIndex)
    },
    handleRemoveTabFromPagePlot(plotId, tabIndex) {
      this.isUpdated = true
      this.onRemoveTabFromPagePlot(plotId, tabIndex)
    },
    handleUpdateTabViewPagePlot(plotId, tabIndex, hidden) {
      this.isUpdated = true
      this.onUpdateTabViewPagePlot(plotId, tabIndex, hidden)
    },
    handleApplyPagePlot(plotId, plotTypeId, event, options) {
      this.isUpdated = true
      this.onApplyPagePlot(plotId, plotTypeId, event, options)
    },
    handlePlotDialogClose() {
      if (this.onClose) {
        this.onClose(this.pagePlot.id, this.isUpdated, this.isSaved)
        this.isUpdated = false
        this.isSaved = false
      }
    },
    handleAccept() {
      this.handlePlotDialogClose()
      this.currentData = null
    },
  },
}
</script>

<style lang="scss">
.asc-page-plot-dialog--container {
  margin-bottom: 16px;

  .asc-page-plot-wrapper--footer {
    display: inherit !important;

    .asc-caption {
      margin-left: 8px;
    }
  }
}
</style>
